// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_fl","accent":"e_gl","empty":"e_hl","s32":"e_il","s36":"e_jl","s44":"e_kl","s56":"e_ll","s72":"e_ml"};